'use strict'

class Preload {
    run(images, loaded){
        return new Promise((resolve, reject) => {
            let l = images.length;
            let i = 0;
            images.forEach((element) => {
                let img = new Image();
                if(element instanceof HTMLImageElement){
                    if(element.getAttribute('src')){
                        img.src = element.getAttribute('src');
                    }
                } else if(element instanceof HTMLVideoElement){
                    if(!element.getAttribute('poster')){
                        return;
                    }
                    img.src = element.getAttribute('poster');
                } else if(element instanceof Object){
                    let bg = element.style.backgroundImage.slice(4, -1).replace(/"/g, "");
                    if(!bg){
                        return;
                    }
                    img.src = bg;
                } else {
                    img.src = element;
                }
                img.addEventListener('load', () => {
                    i++;
                    loaded(((i * 100) / l), img);
                    if(i>=l){
                        resolve("¡Éxito!");
                    }
                });
                return img;
            });
        });
    }
}

export default Preload;
/*
var counter = $('.image-preload').length;
    $('.image-preload').each(function(e){
        if (!$(this).prop('complete')) {
            $(this).on('load', function () {
                counter--;
                whenImagesAreLoaded(counter, $(this).attr('src'));
            });
            $(this).on('error', function () {
                counter--;
                whenImagesAreLoaded(counter, $(this).attr('src'));
            });
        } else {
            counter--;
            whenImagesAreLoaded(counter, $(this).attr('src'));
        }
    });*/